import React, { useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './styles.css';

// Teen illustrations
import teenBoy1 from '../../assets/hero/teen_boy1.png';
import teenGirl1 from '../../assets/hero/teen_girl1.png';
import teenBoy2 from '../../assets/hero/teen_boy2.png';



// New camp photos
import campHero from '../../assets/hero/campHero.jpg';
import camp1 from '../../assets/hero/camp1.jpg';
import camp2 from '../../assets/hero/camp2.jpg';
import camp3 from '../../assets/hero/camp3.jpg';
import camp4 from '../../assets/hero/camp4.jpg';
import camp5 from '../../assets/hero/camp5.jpg';

// New LCAA photos
import lcaaHero from '../../assets/hero/lcaaHero.jpg';
import lcaa1 from '../../assets/hero/lcaa1.jpg';
import lcaa2 from '../../assets/hero/lcaa2.jpg';
import lcaa3 from '../../assets/hero/lcaa3.jpg';
import lcaa4 from '../../assets/hero/lcaa4.jpg';

// New service photos
import churchService1 from '../../assets/hero/churchService1.jpg';
import churchService2 from '../../assets/hero/churchService2.png';
import churchService3 from '../../assets/hero/churchService3.jpg';
import churchService4 from '../../assets/hero/churchService4.jpg';
import churchService5 from '../../assets/hero/churchService5.jpg';
// New program photos
import programIgnite from '../../assets/hero/programIgnite.jpg';
import programTeevo from '../../assets/hero/programTeevo.jpg';

// School outreach images
import outreach1 from '../../assets/hero/outreach1.jpg';
import outreach2 from '../../assets/hero/outreach2.jpg';
import outreach3 from '../../assets/hero/outreach3.jpg';
import outreach4 from '../../assets/hero/outreach4.jpg';
import outreach5 from '../../assets/hero/outreach5.jpg';
import outreach6 from '../../assets/hero/outreach6.jpg';

// Student conference images
import conf1 from '../../assets/hero/conf1.jpg';
import conf2 from '../../assets/hero/conf2.jpg';
import conf3 from '../../assets/hero/conf3.jpg';
import conf4 from '../../assets/hero/conf4.jpg';
import conf5 from '../../assets/hero/conf5.jpg';
import conf6 from '../../assets/hero/conf6.jpg';
import conf7 from '../../assets/hero/conf7.jpg';
import conf8 from '../../assets/hero/conf8.jpg';
import conf9 from '../../assets/hero/conf9.jpg';

function YouthChurch() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const churchPhotos = [
    { src: churchService1, caption: 'Inspiring Teen Presenters', rotation: '-1.5deg' },
    { src: churchService2, caption: 'Engaging Study & Note-taking', rotation: '3deg' },
    { src: churchService3, caption: 'Heartfelt Worship & Ministry', rotation: '-2.8deg' },
    { src: churchService4, caption: 'Attentive Listeners in Service', rotation: '2deg' },
    { src: churchService5, caption: 'Praise & Vocal Ministry Duet', rotation: '-3.5deg' }
  ];


  return (
    <div className="youth-church-page">
      <Navbar />

      {/* ============ HERO SECTION ============ */}
      <section className="ignite-hero">
        <div className="hero-grid-overlay"></div>
        <div className="hero-glow-radial"></div>

        {/* Decorative elements */}
        <div className="ignite-decor">
          <span className="decor-star star-1">★</span>
          <span className="decor-star star-2">✦</span>
          <span className="decor-star star-3">✦</span>
          <span className="decor-star star-4">★</span>
          <div className="decor-badge-circle">
            <span>IGNITE<br/>YOUTH</span>
          </div>
        </div>

        <div className="ignite-hero-inner">
          <p className="ignite-eyebrow-text">✦ WELCOME TO ✦</p>

          <div className="ignite-wordmark-container">
            <h1 className="ignite-wordmark-large">
              IGNITE
            </h1>
          </div>

          {/* Teen bitmojis overlapping the text, standing at the bottom of the hero */}
          <img src={teenBoy1} className="teen-character character-1" alt="Teen Boy Streetwear" />
          <img src={teenGirl1} className="teen-character character-2" alt="Teen Girl Denim" />
          <img src={teenBoy2} className="teen-character character-3" alt="Teen Boy Casual" />

          <p className="ignite-subtag">we burn 🔥</p>

          {/* Quick core values/highlights tags */}
          <div className="hero-tags-grid">
            <div className="hero-tag-item">
              <span className="tag-title">GROW IN THE WORD</span>
              <span className="tag-sub">Dynamic Bible Teachings</span>
            </div>
            <div className="hero-tag-item">
              <span className="tag-title">BUILD FELLOWSHIP</span>
              <span className="tag-sub">Amazing Teen Community</span>
            </div>
            <div className="hero-tag-item">
              <span className="tag-title">EXPRESS TALENTS</span>
              <span className="tag-sub">Music, Arts & Tech Groups</span>
            </div>
          </div>


        </div>

        {/* Scrolling Marquee ticker strip at bottom */}
        <div className="ignite-marquee">
          <div className="marquee-track">
            <span>IGNITE YOUTH • WORSHIP • POWER • GAMES • COMMUNITY • FAITH • FRIENDS • NO LIMITS • </span>
            <span>IGNITE YOUTH • WORSHIP • POWER • GAMES • COMMUNITY • FAITH • FRIENDS • NO LIMITS • </span>
            <span>IGNITE YOUTH • WORSHIP • POWER • GAMES • COMMUNITY • FAITH • FRIENDS • NO LIMITS • </span>
          </div>
        </div>
      </section>

      {/* ============ MAIN CONTENT CONTAINER (Navbar Size) ============ */}
      <div className="youth-container">
        
        {/* ============ WELCOME & SERVICE TIMES ============ */}
        <section className="youth-welcome-intro">
          <div className="welcome-intro-card">
            <div className="welcome-intro-text">
              <span className="welcome-badge">WELCOME TO IGNITE YOUTH</span>
              <h2 className="welcome-title">TEENS & YOUTH SERVICES</h2>
              <p className="welcome-desc">
                Our Teens & Youth Services are vibrant gatherings designed to inspire, equip, and empower the next generation to live with purpose. Join us for dynamic worship, practical Bible teaching, and a welcoming community where you can connect, learn, and thrive.
              </p>
            </div>
            
            <div className="service-times-box">
              <span className="times-icon">📅</span>
              <h3 className="times-title">JOIN US EVERY SUNDAY</h3>
              <div className="time-row">
                <span className="time-bullet">🕙</span>
                <div className="time-info">
                  <strong>Morning Service</strong>
                  <span>10:00 AM</span>
                </div>
              </div>
              <div className="time-row">
                <span className="time-bullet">🕔</span>
                <div className="time-info">
                  <strong>Evening Service</strong>
                  <span>5:00 PM</span>
                </div>
              </div>
              <p className="times-footer">Everyone is welcome to experience life-transforming fellowship! 🔥</p>
            </div>
          </div>
        </section>
        
        {/* ============ PHOTOS OF THE CHURCH (Visual Journal Stack) ============ */}
        <section className="church-photos-section">
          <div className="youth-section-header">
            <div className="header-badge">VISUAL DIARY</div>
            <h2 className="header-heading">LIFE ON CANVAS: MINISTRY PHOTOS</h2>
            <p className="header-desc">Capturing real moments of worship, laughter, and brotherhood in Ignite Youth.</p>
          </div>

          <div className="visual-journal-grid">
            {churchPhotos.map((photo, index) => (
              <div 
                className={`journal-photo-card card-style-${index + 1}`} 
                key={index} 
                style={{ 
                  transform: `rotate(${photo.rotation})`,
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <div className="photo-tape-strip"></div>
                <div className="journal-img-box">
                  <img src={photo.src} alt={photo.caption} className="journal-img" />
                </div>
                <div className="journal-caption">{photo.caption}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ============ DIMENSIONS OF GROWTH ============ */}
        <section className="growth-dimensions-section">
          <div className="youth-section-header">
            <div className="header-badge">AREAS OF IMPROVEMENT</div>
            <h2 className="header-heading">IGNITE YOUR POTENTIAL: DIMENSIONS OF GROWTH</h2>
            <p className="header-desc">Growth is holistic. In Ignite Youth, we foster training and mentorship across five critical coordinates of your life.</p>
          </div>

          <div className="growth-cards-grid">
            <div className="growth-card">
              <span className="growth-number">01</span>
              <h3 className="growth-title">Relationship with God</h3>
              <p className="growth-text">Nurture deep spiritual roots, form personal prayer habits, and build an effective, daily walk with God through active word study.</p>
            </div>
            <div className="growth-card">
              <span className="growth-number">02</span>
              <h3 className="growth-title">Build Your Confidence</h3>
              <p className="growth-text">Overcome social anxiety, stand firm in your convictions, and find your voice through communication training and public speaking opportunities.</p>
            </div>
            <div className="growth-card">
              <span className="growth-number">03</span>
              <h3 className="growth-title">Leadership Skillsets</h3>
              <p className="growth-text">Discover how to lead effectively, coordinate service projects, manage teams, and take responsibility for guiding peers in your community.</p>
            </div>
            <div className="growth-card">
              <span className="growth-number">04</span>
              <h3 className="growth-title">Quality Lifestyle</h3>
              <p className="growth-text">Form wholesome life habits, set high standards of moral character, focus on academic excellence, and practice clean, healthy daily living.</p>
            </div>
            <div className="growth-card">
              <span className="growth-number">05</span>
              <h3 className="growth-title">Purposeful Living</h3>
              <p className="growth-text">Identify your unique talents, discover your divine calling, align your career ambitions, and begin living every single day with clear intent.</p>
            </div>
          </div>
        </section>

        {/* ============ IGNITE SUMMER CAMP (Modern Dark Grid Style) ============ */}
        <section id="camps" className="summer-camps-section">
          <div className="youth-section-header">
            <div className="header-badge">CAMP RETROSPECTIVE</div>
            <h2 className="header-heading">IGNITE SUMMER CAMP</h2>
            <p className="header-desc">A recap of our annual gathering where young lives were transformed, filled with adventure and the word.</p>
          </div>

          <div className="camp-retro-container">
            <div className="camp-retro-grid">
              
              {/* Left Column: Visual Showcase & Stats */}
              <div className="camp-retro-left">
                <div className="camp-img-box-modern">
                  <img src={campHero} alt="Ignite Summer Camp Group" className="camp-img-modern" />
                  <div className="camp-img-caption-modern">Ignite Summer Camp Group 🇮🇳</div>
                </div>

                {/* Modern Dark Stat Grid */}
                <div className="camp-stats-grid-modern">
                  <div className="camp-stat-card-modern">
                    <span className="stat-num">100+</span>
                    <span className="stat-txt">Teens Joined</span>
                  </div>
                  <div className="camp-stat-card-modern">
                    <span className="stat-num">5 Days</span>
                    <span className="stat-txt">Of Fire & Fun</span>
                  </div>
                  <div className="camp-stat-card-modern highlighted-stat">
                    <span className="stat-num">10+</span>
                    <span className="stat-txt">States Came Together</span>
                  </div>
                </div>
              </div>

              {/* Right Column: Descriptions & Testimonial Quotes */}
              <div className="camp-retro-right">
                <div className="camp-text-box-modern">
                  <div className="content-badge-gold">CAMP EXPERIENCE</div>
                  <h3 className="camp-heading-modern">TRANSFORMING LIVES IN THE WILDERNESS</h3>
                  <p className="camp-desc-modern">
                    Our annual summer camps are designed to get teenagers out of their comfort zones and into an environment charged with faith, brotherhood, and raw fun. Through team-building activities, outdoor sports, and deep sessions in the Word, teenagers forge lifelong friendships and discover their true identity in Christ.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Camp collage after section 4 */}
        <div className="youth-section-collage camp-collage">
          <div className="collage-grid-5">
            <div className="collage-photo-frame rot-left">
              <img src={camp1} alt="Camp Worship Session" />
              <span>Camp Praise & Worship</span>
            </div>
            <div className="collage-photo-frame rot-right">
              <img src={camp2} alt="Outdoor Lecture Session" />
              <span>Amphitheater Study Sessions</span>
            </div>
            <div className="collage-photo-frame rot-left-light">
              <img src={camp3} alt="Auditorium Focus Circles" />
              <span>Auditorium Focus Circles</span>
            </div>
            <div className="collage-photo-frame rot-right-light">
              <img src={camp4} alt="CPR Dummy Training" />
              <span>CPR & First-Aid Workshops</span>
            </div>
            <div className="collage-photo-frame rot-left">
              <img src={camp5} alt="Outdoor Whiteboard Worship" />
              <span>Outdoor Group Worship</span>
            </div>
          </div>
        </div>

        {/* ============ LOVEWORLD CREATIVE ARTS ACADEMY (LCAA) ============ */}
        <section className="lcaa-section">
          <div className="lcaa-container-box">
            <div className="lcaa-grid">
              <div className="lcaa-text-box">
                <div className="content-badge-gold">ARTS & CULTURE</div>
                <h3 className="lcaa-heading">LOVEWORLD CREATIVE ARTS ACADEMY (LCAA)</h3>
                <p className="lcaa-desc">
                  The LoveWorld Creative Arts Academy (LCAA) is a global creative and performing arts initiative under the LoveWorld Music and Arts Ministry (LMAM) and Christ Embassy. It trains youth and adults in dance, drama, poetry, and media to minister through the arts.
                </p>
                <p className="lcaa-achievement">
                  Globally, the academy is well-known for its vibrant, spirit-filled performances at major events like the annual <strong>LoveWorld International Music and Arts Awards (LIMAA)</strong> and the <strong>LoveWorld Festival of Music and Arts (LFMA)</strong>.
                </p>
              </div>
              <div className="lcaa-img-box">
                <div className="lcaa-tape-strip"></div>
                <img src={lcaaHero} alt="LCAA Performing Arts" className="lcaa-img" />
                <div className="lcaa-img-caption">Creative Arts Dance Rehearsal</div>
              </div>
            </div>
          </div>
        </section>

        {/* LCAA collage after section 5 */}
        <div className="youth-section-collage lcaa-collage">
          <div className="collage-grid-4">
            <div className="collage-photo-frame rot-right">
              <img src={lcaa1} alt="Choreography & Stage Performance" />
              <span>Choreography & Stage Performance</span>
            </div>
            <div className="collage-photo-frame rot-left">
              <img src={lcaa2} alt="LCAA Stage Art Showcase" />
              <span>LCAA Stage Art Showcase</span>
            </div>
            <div className="collage-photo-frame rot-right-light">
              <img src={lcaa3} alt="Expressive Solo Performances" />
              <span>Expressive Solo Performances</span>
            </div>
            <div className="collage-photo-frame rot-left-light">
              <img src={lcaa4} alt="Vocal and Choir Ministry" />
              <span>Vocal & Choir Ministry</span>
            </div>
          </div>
        </div>

        {/* ============ STUDENT CONFERENCES ============ */}
        <section className="outreaches-section student-conferences-section">
          <div className="youth-section-header">
            <div className="header-badge">ANNUAL EVENTS</div>
            <h2 className="header-heading">STUDENT CONFERENCES</h2>
            <p className="header-desc">Empowering, educating, and inspiring the next generation of leaders.</p>
          </div>

          <div className="conference-content-grid">
            <div className="conf-text-column">
              <p className="conf-lead-text">
                Our Student Conference is a life-changing experience designed to inspire, educate, and empower students to become confident, purpose-driven leaders. It brings together students from diverse backgrounds in an engaging environment where they are encouraged to discover their potential, develop essential life skills, and build meaningful relationships.
              </p>
              <p className="conf-body-text">
                The conference features inspiring keynote sessions, interactive workshops, leadership training, career guidance, mentorship, and practical skill-building activities. Participants gain valuable knowledge in areas such as communication, teamwork, critical thinking, emotional intelligence, financial literacy, entrepreneurship, creativity, and personal development.
              </p>
              <p className="conf-body-text">
                Beyond learning, the conference provides opportunities for students to connect with mentors, industry professionals, and like-minded peers, fostering collaboration and lifelong friendships. Through engaging discussions, group activities, and real-life experiences, students are equipped with the confidence, character, and vision needed to excel academically, professionally, and personally.
              </p>
              <p className="conf-body-text">
                Our goal is to raise a generation of responsible, compassionate, and innovative young leaders who are prepared to make a positive impact in their schools, communities, and the world. Every conference is designed to challenge, inspire, and equip students with the mindset and skills they need to succeed in an ever-changing world.
              </p>
            </div>
            
            <div className="conf-sidebar-card">
              <span className="conf-sidebar-icon">🎓</span>
              <h4>KEY FOCUS AREAS</h4>
              <ul>
                <li>🏆 Keynote Sessions</li>
                <li>🛠️ Interactive Workshops</li>
                <li>👔 Leadership Training</li>
                <li>💼 Career Guidance</li>
                <li>🤝 Professional Mentorship</li>
                <li>🎯 Skill-Building Activities</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Student Conferences Collage */}
        <div className="youth-section-collage conference-collage">
          <div className="conf-collage-title">CONFERENCE DIARY & GALLERY</div>
          <div className="conf-collage-grid">
            <div className="conf-photo-card card-1">
              <div className="conf-tape-strip"></div>
              <img src={conf1} alt="Student Registration" />
              <span>Conference Registration Desk</span>
            </div>
            <div className="conf-photo-card card-2">
              <div className="conf-tape-strip"></div>
              <img src={conf2} alt="Students Stage Awards" />
              <span>Stage Presentations & Awards</span>
            </div>
            <div className="conf-photo-card card-3">
              <div className="conf-tape-strip"></div>
              <img src={conf3} alt="Auditorium Session" />
              <span>Auditorium Leadership Sessions</span>
            </div>
            <div className="conf-photo-card card-4">
              <div className="conf-tape-strip"></div>
              <img src={conf4} alt="Massive Hall Audience" />
              <span>Pune Student Congregation</span>
            </div>
            <div className="conf-photo-card card-5">
              <div className="conf-tape-strip"></div>
              <img src={conf5} alt="Group Team Shot" />
              <span>Team & Mentor Panel</span>
            </div>
            <div className="conf-photo-card card-6">
              <div className="conf-tape-strip"></div>
              <img src={conf6} alt="CPR Training Session" />
              <span>Interactive Life-Skills Segment</span>
            </div>
            <div className="conf-photo-card card-7">
              <div className="conf-tape-strip"></div>
              <img src={conf7} alt="Student CPR Practice" />
              <span>CPR Practical Workshops</span>
            </div>
            <div className="conf-photo-card card-8">
              <div className="conf-tape-strip"></div>
              <img src={conf8} alt="Stage Presenter Addressing Students" />
              <span>Auditorium Keynote Presentation</span>
            </div>
            <div className="conf-photo-card card-9">
              <div className="conf-tape-strip"></div>
              <img src={conf9} alt="Audience Raised Hands" />
              <span>Interactive Q&A Session</span>
            </div>
          </div>
        </div>

        {/* ============ TEENSPIRATION ============ */}
        <section className="teenspiration-section">
          <div className="teenspiration-board">
            <div className="teensp-pin"></div>
            <div className="teenspiration-header">
              <span className="teensp-badge">GLOBAL NETWORK</span>
              <h3 className="teensp-title">TEENSPIRATION</h3>
              <p className="teensp-subtitle">About Teenspiration</p>
            </div>

            <div className="teenspiration-columns">
              <div className="teensp-col-left">
                <p className="teensp-main-text">
                  Teenspiration is a movement dedicated to raising confident, purpose-driven, and impactful teenagers.
                </p>
                <p className="teensp-body-text">
                  We believe that true growth extends beyond faith alone—it encompasses character, leadership, creativity, practical skills, emotional well-being, and career readiness.
                </p>
                <p className="teensp-body-text">
                  Our mission is to equip teenagers with the knowledge, values, and opportunities they need to thrive in every area of life. Through mentorship, leadership development, life-skills training, creative expression, and spiritual guidance, we help young people discover their unique gifts, unlock their full potential, and build a strong foundation for their future.
                </p>
                <p className="teensp-body-text">
                  At Teenspiration, we are committed to nurturing teenagers who are spiritually grounded, emotionally resilient, intellectually equipped, and socially responsible. We inspire them to lead with integrity, serve with compassion, and confidently make a positive impact in their families, communities, and the world.
                </p>
              </div>
              <div className="teensp-col-right">
                <div className="teensp-vision-mission-box">
                  <div className="teensp-vision-box">
                    <span className="teensp-icon-gold">👁️‍🗨️</span>
                    <h4 className="teensp-right-title">OUR VISION</h4>
                    <p className="teensp-right-text">
                      To raise a generation of confident, purpose-driven leaders who are equipped with strong values, practical skills, and a heart to transform their communities and the world.
                    </p>
                  </div>
                  <div className="teensp-mission-box">
                    <span className="teensp-icon-gold">🎯</span>
                    <h4 className="teensp-right-title">OUR MISSION</h4>
                    <p className="teensp-right-text">
                      To empower teenagers through mentorship, leadership development, life-skills training, creative opportunities, and spiritual growth—preparing them to become responsible leaders, innovative thinkers, and agents of positive change.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Teenspiration photo journal collage (using the 6 uploaded images) */}
        <div className="youth-section-collage teensp-collage">
          <div className="teensp-collage-title">TEENSPIRATION MOVEMENT IN ACTION</div>
          <div className="teensp-collage-grid">
            <div className="teensp-photo-card card-1">
              <div className="teensp-tape-strip"></div>
              <img src={outreach1} alt="Teensspiration Assembly Ground" />
              <span>Outdoor Youth Assemblies</span>
            </div>
            <div className="teensp-photo-card card-2">
              <div className="teensp-tape-strip"></div>
              <img src={outreach2} alt="Teen Inspiration Session Close-up" />
              <span>Engaged Minds</span>
            </div>
            <div className="teensp-photo-card card-3">
              <div className="teensp-tape-strip"></div>
              <img src={outreach3} alt="Teensspiration Crowd Aerial View" />
              <span>Assembly Gathering Ground</span>
            </div>
            <div className="teensp-photo-card card-4">
              <div className="teensp-tape-strip"></div>
              <img src={outreach4} alt="Inspiring Teen Presenters" />
              <span>Mentorship & Career Talks</span>
            </div>
            <div className="teensp-photo-card card-5">
              <div className="teensp-tape-strip"></div>
              <img src={outreach5} alt="Group Interaction Sessions" />
              <span>Student Workshops</span>
            </div>
            <div className="teensp-photo-card card-6">
              <div className="teensp-tape-strip"></div>
              <img src={outreach6} alt="Teenspiration Stage Team" />
              <span>Teenspiration Stage Presentation</span>
            </div>
          </div>
        </div>

        {/* ============ PROGRAMS (The Flyer Bulletin Board) ============ */}
        <section id="programs" className="programs-section">
          <div className="youth-section-header">
            <div className="header-badge">WEEKLY CONNECTS</div>
            <h2 className="header-heading">YOUTH PROGRAMS & SCHEDULES</h2>
            <p className="header-desc">We gather multiple times a week to stay built in the word and connected as a unit.</p>
          </div>

          <div className="bulletin-board-grid">
            
            {/* Sunday Flyer (Notebook Style) - IGNITE */}
            <div className="bulletin-flyer flyer-sunday">
              <div className="flyer-tape-top"></div>
              <div className="flyer-badge">IGNITE talk show</div>
              <h3 className="flyer-title">IGNITE TALK SHOW</h3>
              <p className="flyer-time">🎬 Weekly Broadcast</p>
              
              {/* Program Thumbnail */}
              <div className="flyer-thumbnail">
                <img src={programIgnite} alt="Ignite Talk Show Session" />
              </div>

              <div className="flyer-notebook-lines">
                <p>• We built more than a show—we built a voice 🎬🔥</p>
                <p>• Heart-to-heart conversations about real struggles 💬</p>
                <p>• Discovering hope, light, and true guidance ✨</p>
                <p>• Honest teenage conversations you can relate to</p>
              </div>

              <div className="flyer-bottom-tag">LISTEN & WATCH</div>
            </div>

            {/* Wednesday Flyer (Taped Blueprint Style) - TEEVO BLAZE */}
            <div className="bulletin-flyer flyer-wednesday">
              <div className="flyer-tape-diagonal"></div>
              <div className="flyer-badge">TEEVO BLAZE devotion</div>
              <h3 className="flyer-title">TEEVO BLAZE SESSIONS</h3>
              <p className="flyer-time">📖 Daily Devotional Study</p>
              
              {/* Program Thumbnail */}
              <div className="flyer-thumbnail">
                <img src={programTeevo} alt="Teevo Blaze Devotional Segment" />
              </div>

              <div className="flyer-blueprint-details">
                <p className="bp-label">OBJECTIVE:</p>
                <p className="bp-text">Understanding and learning new things every day from the Rhapsody TeeVo.</p>
                
                <p className="bp-label">DAILY SCRIPTURE:</p>
                <p className="bp-text font-accent">A solid devotional word of faith for each day.</p>
              </div>

              <div className="flyer-footer-stamp">DAILY WORD</div>
            </div>

          </div>
        </section>

        {/* ============ SOCIAL & CONNECT BOX ============ */}
        <section className="youth-social-section">
          <div className="social-card-v2">
            <div className="social-decor-ring"></div>
            <div className="social-card-inner">
              <h3 className="social-heading">BE PART OF THE IGNITE FAMILY</h3>
              <p className="social-sub">Don't miss a single beat. Follow us online to get weekly study guides, video highlights, and community announcements.</p>
              
              <div className="social-links-v2">
                <a href="https://www.instagram.com/ceindia2_teens_youths/" target="_blank" rel="noreferrer" className="social-anchor instagram">
                  <span className="icon-span">📸</span>
                  <div className="text-span">
                    <strong>INSTAGRAM</strong>
                    <span>@ceindia2_teens_youths</span>
                  </div>
                </a>

                <a href="https://www.youtube.com/@ceindia2_teens_youth" target="_blank" rel="noreferrer" className="social-anchor youtube">
                  <span className="icon-span">▶</span>
                  <div className="text-span">
                    <strong>YOUTUBE</strong>
                    <span>@ceindia2_teens_youth</span>
                  </div>
                </a>

                <a href="https://www.facebook.com/teensandyouthchurch/" target="_blank" rel="noreferrer" className="social-anchor facebook">
                  <span className="icon-span">📘</span>
                  <div className="text-span">
                    <strong>FACEBOOK</strong>
                    <span>Teens & Youth Ministry</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}

export default YouthChurch;